// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"styles_breadcrumb__9ZJ3q","current":"styles_current__3mpt5","dark":"styles_dark__3p3RE","light":"styles_light__5kIU4"};